"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHelmet = require("react-helmet");
var _lodash = require("lodash");
var _imageSrc = require("../lib/imageSrc");
var _dateFns = require("date-fns");
var _siteHelper = require("../lib/siteHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var HeadTags = props => {
  var _fields$TealiumNoPage;
  var {
    fields,
    env
  } = props;
  var tagTealiumEnv = env === 'preview' ? 'prod' : env === 'fb' ? 'dev' : env;
  var robots = (0, _siteHelper.robotsStatus)({
    robotsNoIndex: fields.robotsNoIndex.value,
    robotsNoFollow: fields.robotsNoFollow.value
  });
  var tealiumType = (0, _lodash.isEmpty)(props.tealiumType) ? 'main' : props.tealiumType;
  var tealiumParam = {
    env: tagTealiumEnv,
    app: props.appName,
    addUtagLoginCookie: props.addUtagLoginCookie,
    pageQuery: props.pageQuery,
    utagSiteName: props.utagSiteName,
    initialUtags: {
      page_category: "".concat(fields.PageCategory.value),
      page_name: "".concat(fields.PageName.value),
      content_type: "".concat(fields.ContentType.value)
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, fields.Title.value), !(0, _lodash.isEmpty)(props.tealiumType) && /*#__PURE__*/_react.default.createElement("script", {
    type: "application/ld+json",
    src: "//tags.tiqcdn.com/utag/massmutual/".concat(tealiumType, "/").concat(tagTealiumEnv, "/utag.sync.js")
  }), !(0, _lodash.isEmpty)(props.tealiumType) && ((_fields$TealiumNoPage = fields.TealiumNoPageview) === null || _fields$TealiumNoPage === void 0 ? void 0 : _fields$TealiumNoPage.value) && /*#__PURE__*/_react.default.createElement("script", {
    type: "text/javascript"
  }, "window.utag_cfg_ovrd = { noview: true };"), !(0, _lodash.isEmpty)(props.tealiumType) && /*#__PURE__*/_react.default.createElement("script", {
    src: "/dist/js/tealiumTagging.js",
    "data-args": JSON.stringify((0, _siteHelper.tealiumTags)(tealiumParam)),
    type: "text/javascript"
  }), props.appName === 'mmcom' && fields.PageType.value === 'home' && /*#__PURE__*/_react.default.createElement("script", {
    type: "application/ld+json"
  }, "\n      {\n        '@context': 'http://schema.org',\n        '@type': 'WebSite',\n        'name': 'MassMutual Insurance and Financial Services',\n        'url': 'https://www.massmutual.com/',\n        'potentialAction' : {\n          '@type' : 'SearchAction',\n          'target' : 'https://www.massmutual.com/search?query={search_term_string}',\n          'query-input' : 'required name=search_term_string'\n        }\n      }\n      "), props.appName === 'mmcom' && fields.PageType.value === 'home' && /*#__PURE__*/_react.default.createElement("script", {
    type: "application/ld+json"
  }, "\n      {\n        '@context': 'http://schema.org',\n        '@type': 'Organization',\n        'name': 'MassMutual Insurance and Financial Services',\n        'url': 'https://www.massmutual.com/',\n        'logo': 'https://www.massmutual.com/global-images/logo_MM-white.svg',\n        'image': 'https://www.massmutual.com/global-images/logo_MM-white.svg',\n        'contactPoint': {\n          '@type': 'ContactPoint',\n          'contactType': 'customer service',\n          'telephone': '+18002722216'\n          },\n        'sameAs': [\n          'https://www.facebook.com/massmutual',\n          'https://twitter.com/massmutual',\n          'https://www.linkedin.com/company/massmutual-financial-group',\n          'https://www.youtube.com/user/MassMutual',\n          'https://www.pinterest.com/massmutual/'\n        ]\n      }\n      "), /*#__PURE__*/_react.default.createElement("meta", {
    name: "title",
    content: (0, _lodash.isEmpty)(fields.MetaSearchResultTitle.value) ? fields.MetaTitle.value : fields.MetaSearchResultTitle.value
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: (0, _lodash.isEmpty)(fields.MetaSearchResultDescription.value) ? fields.MetaDescription.value : fields.MetaSearchResultDescription.value
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: fields.MetaTitle.value
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: fields.MetaDescription.value
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: (0, _lodash.isEmpty)(fields.seoCanonicalTag.value) ? (0, _siteHelper.pageUri)({
      pagePath: props.pagePath
    }) : fields.seoCanonicalTag.value
  }), fields.PageType.value === 'blogpost' && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: (0, _imageSrc.imageHref)(fields.MainImage.value)
  }), fields.PageType.value === 'blogpost' && /*#__PURE__*/_react.default.createElement("meta", {
    property: "article:author",
    content: fields.Author[0].name
  }), fields.PageType.value === 'blogpost' && /*#__PURE__*/_react.default.createElement("meta", {
    property: "article:published_time",
    content: (0, _dateFns.format)(new Date(fields.Date.value), 'MMMM dd, yyyy')
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: fields.ogType.value
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "mm-search-exclude",
    content: fields.ExcludeFromSearch.value
  }), !(0, _lodash.isEmpty)(fields.ContentType.value) && /*#__PURE__*/_react.default.createElement("meta", {
    name: "contentType",
    content: fields.ContentType.value
  }), !(0, _lodash.isEmpty)(fields.MetaProductCategory.value) && /*#__PURE__*/_react.default.createElement("meta", {
    name: "productCategory",
    content: fields.MetaProductCategory.value
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "mm-page-content",
    content: props.itemId
  }), fields.GoogleSiteIDList && (0, _lodash.map)(fields.GoogleSiteIDList, (googleSiteIdItem, itemIndex) => {
    var _googleSiteIdItem$fie;
    if (!(0, _lodash.isEmpty)((_googleSiteIdItem$fie = googleSiteIdItem.fields) === null || _googleSiteIdItem$fie === void 0 || (_googleSiteIdItem$fie = _googleSiteIdItem$fie.Value) === null || _googleSiteIdItem$fie === void 0 ? void 0 : _googleSiteIdItem$fie.value)) {
      return /*#__PURE__*/_react.default.createElement("meta", {
        name: "google-site-verification",
        content: googleSiteIdItem.fields.Value.value,
        key: itemIndex
      });
    } else return null;
  }), env !== 'prod' ? /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: 'noindex, nofollow'
  }) : robots === 'na' ? /*#__PURE__*/_react.default.createElement("link", {
    rel: "canonical",
    href: (0, _lodash.isEmpty)(fields.seoCanonicalTag.value) ? (0, _siteHelper.pageCanonical)({
      pagePath: props.pagePath,
      pageQuery: props.pageQuery
    }) : fields.seoCanonicalTag.value
  }) : /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: robots
  }));
};
var _default = exports.default = HeadTags;